import axios from '@utils/axios';

const createEditUser = {
  state: {
    name: '',
    price: 0
  },
  mutations: {
    setName(state, name) {
      state.name = name;
    },
    setPrice(state, price) {
      state.price = price;
    }
  },
  actions: {
    createProductType(context) {
      return axios.put('admin/producttypes/create', {
        Name: context.state.name,
        Price: Number(context.state.price)
      });
    },
    resetContext(context) {
      context.commit('setName', '');
      context.commit('setPrice', 0);
    },
  },
  namespaced: true
};

export default createEditUser;
